/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Edit_Contract_Start_LockedInputs */



/**
* | output |
* | --- |
* | "The term has started, so its start date is fixed." |
*
* @param {Partner_Edit_Contract_Start_LockedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_edit_contract_start_locked = /** @type {((inputs?: Partner_Edit_Contract_Start_LockedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Edit_Contract_Start_LockedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Laufzeit hat begonnen, daher steht das Startdatum fest.")
	return /** @type {LocalizedString} */ ("The term has started, so its start date is fixed.")
});